import MyProfilePage from './MyProfilePage';
import { MyProfilePageProps, MyProfilePageValueProps } from './types';

export type { MyProfilePageProps, MyProfilePageValueProps };
export default MyProfilePage;
